import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Hero from './components/Hero';
import Intro from './components/Intro';
import TentGrid from './components/TentGrid';
import FabricFeatures from './components/FabricFeatures';
import NeedToKnow from './components/NeedToKnow';
import BottomCTA from './components/BottomCTA';
import CertificationBanner from '@/components/feature/CertificationBanner';
import { productJsonLd } from '@/components/feature/ProductJsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://popprotents.com';

const jsonLd = productJsonLd({
  name: 'Standard Stretch Tents — Premium Event Rentals | Pop Pro Tents',
  description: 'High-quality standard stretch tents available for rent across Texas. Waterproof, fire-rated, UV-resistant fabric in multiple sizes. Professional installation included for weddings, festivals, corporate and private events.',
  url: `${siteUrl}/products/standard-stretch-tents`,
  category: 'Stretch Tents',
});

export default function StandardStretchTents() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <CertificationBanner />
        <TentGrid />
        <FabricFeatures />
        <NeedToKnow />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}